import { IPlannerDayModel } from "../models/plannerDayModel";

export const createCacheKey = (year: number, month: number): string => 
  `${year}-${month}`;

export const shouldUpdateCache = (
  dataUpdatedAt: number,
  cacheTimestamps: Map<string, number>,
  cacheKey: string
): boolean => {
  const lastCachedTime = cacheTimestamps.get(cacheKey) || 0;
  return dataUpdatedAt > lastCachedTime;
};

export const updateEventsCache = (
  currentCache: Map<string, IPlannerDayModel[]>,
  cacheKey: string,
  newEvents: IPlannerDayModel[]
): Map<string, IPlannerDayModel[]> => {
  return new Map(currentCache).set(cacheKey, newEvents);
};

export const updateCacheTimestamps = (
  currentTimestamps: Map<string, number>,
  cacheKey: string,
  timestamp: number
): Map<string, number> => {
  return new Map(currentTimestamps).set(cacheKey, timestamp);
};

export const getAllEventsFromCache = (
  eventsCache: Map<string, IPlannerDayModel[]>
): IPlannerDayModel[] => {
  return Array.from(eventsCache.values()).flat();
};